<template>
    <section class="section-hero section-shaped my-0">
        <div class="shape shape-style-1 shape-primary">
            <span class="span-150"></span>
            <span class="span-50"></span>
            <span class="span-50"></span>
            <span class="span-75"></span>
            <span class="span-100"></span>
            <span class="span-75"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
            <span class="span-50"></span>
            <span class="span-100"></span>
        </div>
        <div class="container shape-container d-flex align-items-center">
            <div class="col px-0">
                <div class="row justify-content-center align-items-center">
                    <div class="col-md-6 col-lg-7 pb-5 text-center text-md-left">

                        <h2 class="text-white">¿Que impacto podría tener sobre la salud humana el estímulo de una mascota?</h2>

                        <p class="lead text-white">La Lic. Adriana Miriam Galfré, expone su trabajo desde una mirada neuropsicológica donde la comunicación humano-animal podría ser un instrumento valioso en niños con problemas motrices severos</p>
                        
                        <div class="btn-wrapper">
                            <router-link
                                to="/descarga"
                                class="btn btn-lg btn-warning mb-3 mb-sm-0"
                                icon="fa fa-download"
                                >
                                Descarga el libro gratis
                            </router-link>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-5">
                        <div class="my-3 my-sm-0">
                            <img src="img/theme/book-1.png" alt="book mirame" class="img-fluid">
                        </div>
                    </div>
                </div>               
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
</style>
